const enum LocalConstants {
  SportsOfferingBase = 'kambi-sports-offering',
}

export const sportsOfferingQueryKeys = {
  BetOffersByIds: [LocalConstants.SportsOfferingBase, 'bet-offers-by-ids'],

  EventGroupsFromRoot: [LocalConstants.SportsOfferingBase, 'groups', 'events-groups-from-root'],
  EventGroupHighlights: [LocalConstants.SportsOfferingBase, 'groups', 'highlight'],
  EventsForGroupId: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
    'events',
  ],
  EventsForSport: (sport: string) => [LocalConstants.SportsOfferingBase, 'sport', sport, 'events'],
  UpcomingEventsForAllSports: [
    LocalConstants.SportsOfferingBase,
    'events',
    'upcoming',
    'all-sports',
  ],
  LiveEventsForAllSports: [LocalConstants.SportsOfferingBase, 'events', 'live', 'all-sports'],
  Group: (groupId: number | null) => [
    LocalConstants.SportsOfferingBase,
    'group',
    groupId ?? 'null',
  ],
  EventsForCompetition: (sport: string, region: string, league: string) => [LocalConstants.SportsOfferingBase, 'sport', sport, region, league],
} as const
